<!-- 首页 -->
<template>
  <div class="indexPage">
    <topTitle></topTitle>
    <div class="indexCon">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
	 <footerCon></footerCon>
   <div class="topIcon" @click="topScroll">
     <i class="el-icon-top"></i>
   </div>
  </div>
</template>

<script>
	import topTitle from '../components/topTitle.vue'
	import footerCon from '../components/footerCon.vue'
  export default {
    components: {topTitle,footerCon},
    data() {
      return {
      
      }
    },
    mounted(){
      
    },
    watch: {
      
    },
    methods:{
      topScroll(){
        document.documentElement.scrollTop = 0;
  			document.body.scrollTop = 0;
        
      }
    }
  }
</script>

<style scoped lang="scss">
.topIcon{
  width:45px;
  height: 45px;
  border-radius: 50%;
  background-color: #fff;
  border:1px solid #409eff;
  position: fixed;
  right:30px;
  bottom:30px;
  text-align: center;
  cursor: pointer;
  i{
    font-size: 26px;
    color:#409eff;
    line-height: 45px;
  }
}
.indexCon{
  margin-top:69px;
}
</style>
